import Icon from 'veui/components/Icon'
import { IconShare } from 'dls-icons-vue'

Icon.register('share', IconShare)
